// extracted by mini-css-extract-plugin
module.exports = {"sideContact":"SideContact-module--side-contact--2Q5BP","infoWrapper":"SideContact-module--info-wrapper--2Tzno"};